import { IntlShape } from 'react-intl';

import { MenuObjectTypes } from 'enums/menu';
import { CartEntryType } from 'generated/rbi-graphql';
import { IDayPartBoundary, IValidDayPart } from 'state/day-part/hooks/use-active-day-parts';
import { LoyaltyReward } from 'state/loyalty/types';
import { IMenuItem, getMenuItemDayParts, isAvailableForActiveDayParts } from 'utils/availability';

export const makeUrlForReward = ({ incentives }: LoyaltyReward) => {
  // Ensure incentives are available
  if (!incentives?.length) {
    return;
  }
  // Find first incentive that is not a discount;
  const availableIncentive = incentives.find(
    incentive => incentive?._type !== MenuObjectTypes.OFFER_DISCOUNT
  );

  const { _type, _id } = availableIncentive || {};

  if (!_type || !_id) {
    return;
  }

  return `/menu/${_type}-${_id}?reward=${_id}`;
};

interface IMakeRewardUnavailableMessageArgs {
  reward: LoyaltyReward;
  dayParts: ReadonlyArray<IValidDayPart>;
  formatMessage: IntlShape['formatMessage'];
  isRewardAvailableForDayPart: boolean;
  stagedCartPoints: number;
  pointCost?: number;
  locked?: boolean | null;
}

interface ICheckRewardAvailableForDayPart {
  reward: LoyaltyReward;
  activeDayParts: IDayPartBoundary[];
}

export const checkRewardAvailableForDayPart = ({
  reward,
  activeDayParts,
}: ICheckRewardAvailableForDayPart) => {
  if (!reward?.incentives?.length) {
    return true;
  }
  // For now get first incentive, future implementation TBD
  const [incentiveItem] = reward.incentives;

  if (incentiveItem?._type === CartEntryType.OFFERDISCOUNT) {
    return true;
  }

  const result = isAvailableForActiveDayParts({
    activeDayParts,
    menuData: incentiveItem as IMenuItem,
  });

  return result;
};

export const makeOfferUnavailableMessage = ({
  dayParts,
  isRewardAvailableForDayPart,
  formatMessage,
  locked,
  pointCost = 0,
  reward,
  stagedCartPoints,
}: IMakeRewardUnavailableMessageArgs) => {
  if (locked) {
    return;
  }

  let message = undefined;

  if (!isRewardAvailableForDayPart && reward?.incentives?.length) {
    const [incentiveItem] = reward.incentives;

    const dayPartsSet = new Set(getMenuItemDayParts(incentiveItem as IMenuItem));

    const rewardDaypart = dayParts.find(
      (dayPart: any) => dayPart.key && dayPartsSet.has(dayPart.key.toLowerCase())
    );

    message = formatMessage(
      { id: rewardDaypart ? 'nonAvailableRewardUntilX' : 'nonAvailableReward' },
      {
        time: rewardDaypart?.startTime,
      }
    );
  }

  if (!message && stagedCartPoints < pointCost) {
    message = formatMessage({ id: 'exceedsRewardsBalance' });
  }

  return message;
};
